import React, { Component } from 'react';
import './TeamStats.css';

import ClockIcon from '../../../img/homepage/clock-icon.png';
import GearIcon from '../../../img/homepage/gear-icon-2.png';
import SpeedIcon from '../../../img/homepage/speed-icon-2.png';

/*
const stats = [
  {
    id: 1,
    value: '10 000+',
    labelTop: 'Student work hours',
    labelBottom: 'last season',
    icon: '⏱', // placeholder – replace with SVG if you like
  },
  {
    id: 2,
    value: '150+',
    labelTop: 'Current team members',
    labelBottom: '',
    icon: '⚙️', // placeholder
  },
  {
    id: 3,
    value: '105 km/h',
    labelTop: 'Top speed',
    labelBottom: '',
    icon: '💨', // placeholder
  },
];*/

export class TeamStats extends Component {

  render() {
    return (
      <section id = "team-stats">
        <div className="team-stats-container">

          {/* Stat 1 */}

          <div className="stat-item">
            <div className="stat-top">
              <img src={ClockIcon} alt="Clock Icon" className='stat-icon'/>
              <div className="stat-value">10,000+</div>
            </div>

            <div className="stat-label">
              Student Work Hours
            </div>
          
          </div>

          {/* Stat 2 */}

          <div className="stat-item">
            <div className="stat-top">
              <img src={GearIcon} alt="Gear Icon" className='stat-icon'/>
              <div className="stat-value">150+</div>
            </div>

            <div className="stat-label">
              Current Team Members
            </div>
          
          </div>

          {/* Stat 3 */}

          <div className="stat-item">
            <div className="stat-top">
              <img src={SpeedIcon} alt="Speed Icon" className='stat-icon speed-icon'/>
              <div className="stat-value">105 km/h</div>
            </div>

            <div className="stat-label">
              Top Speed
            </div>
          
          </div>
        </div>
      </section>
    )
  }
}

export default TeamStats;
